import Spinner from 'react-bootstrap/Spinner';

const SpinnerLoader = () => (
  <div className="text-center my-4">
    <Spinner animation="border" role="status" />
    <div>Please wait...</div>
  </div>
);

export default SpinnerLoader;